import { InformationForBorrowingTrainComponent } from "../../../components/borrowSystem/ProposedToTheSubCommittee/InformationForBorrowingTrainComponent";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";

export function InformationForBorrowingTrainContainer () {
    const titleName = "ข้อมูลการขอกู้ยืมกองทุนพัฒนาฝีมือแรงงาน"; //ใส่ชื่อtitle ตรงนี้
    const subtitle = "(สำหรับผู้ดำเนินการฝึกและผู้ประกอบกิจการ)"
    return(
        <div className="page-container bg-landing">
            <NavbarBorrowSystem/>
            <HeadTitle title={titleName} subtitle={subtitle} />
            <InformationForBorrowingTrainComponent/>
            <Footer />
        </div>

    )
}




